<template>
    <v-row dense class="mx-0">
        <v-col :class="setClass" class="pa-lg-0 pl-lg-0 pr-lg-2 pa-sm-0 pl-sm-0 pr-sm-2 pa-md-0 pl-md-0 pr-md-2 pa-xs-0 pl-xs-0 pr-xs-0" v-if="$store.getters.checkModulePermissions('quotations')">
            <v-hover v-slot:default="{ hover }">
                <v-card :elevation="hover ? 4 : 2" class="background-2 round-card">
                    <v-card-title class="pa-1 pl-0 pr-3" style="white-space: nowrap">
                        <v-subheader>Preventivi</v-subheader>
                        <v-spacer></v-spacer>
                        <v-select
                            v-show="expand"
                            v-model="filters['approved_quotation_year']"
                            :items="fieldsset.years"
                            label="Anno"
                            solo flat
                            background-color="background-2"
                            hide-details
                            style="max-width: 100px"
                            dense>
                        </v-select>
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" @click="expand = !expand" :loading="loading" icon>
                                    <v-icon>{{ expand ? 'expand_less' : 'expand_more' }}</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ expand ? 'Contrai' : 'Espandi' }}</span>
                        </v-tooltip>
                    </v-card-title>            
                    <v-expand-transition>
                        <v-card-text class="pa-0" v-show="expand">
                            <div class="flex-column">
                                <span class="display-3 margin-auto info--text font-weight-thin">{{ model.quotation_approved_amount | balance }}</span>
                                <span class="margin-auto text-uppercase font-weight-light pb-4">Accettati</span>
                            </div>
                            <v-divider></v-divider>
                            <div class="pa-4">
                                <span class="font-weight-light">Totale: <span class="font-weight-medium">{{ model.quotation_approved }}</span></span>
                            </div>
                        </v-card-text>
                    </v-expand-transition>
                </v-card>
            </v-hover>
        </v-col>
        <v-col :class="setClass" class="pa-lg-0 pr-lg-2 pl-lg-2 pa-md-0 pl-md-2 pr-md-0 pa-sm-0 pl-sm-2 pr-sm-0 pa-xs-0 pl-xs-0 pr-xs-0 pt-xs-4" v-if="$store.getters.checkModulePermissions('quotations')">
            <v-hover v-slot:default="{ hover }">
                <v-card :elevation="hover ? 4 : 2" class="background-2 round-card">
                    <v-card-title class="pa-1 pl-0 pr-3" style="white-space: nowrap">
                        <v-subheader>Preventivi</v-subheader>
                        <v-spacer></v-spacer>
                        <v-select
                            v-show="expand"
                            v-model="filters['pending_quotation_year']"
                            :items="fieldsset.years"
                            label="Anno"
                            solo flat
                            background-color="background-2"
                            hide-details
                            style="max-width: 100px"
                            dense>
                        </v-select>
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" @click="expand = !expand" :loading="loading" icon>
                                    <v-icon>{{ expand ? 'expand_less' : 'expand_more' }}</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ expand ? 'Contrai' : 'Espandi' }}</span>
                        </v-tooltip>
                    </v-card-title>
                    <v-expand-transition>
                        <v-card-text class="pa-0" v-show="expand">
                            <div class="flex-column">
                                <span class="display-3 margin-auto error--text font-weight-thin">{{ model.quotation_pending_amount | balance }}</span>
                                <span class="margin-auto text-uppercase font-weight-light pb-4">In Attesa</span>
                            </div>
                            <v-divider></v-divider>
                            <div class="pa-4">
                                <span class="font-weight-light">Totale: <span class="font-weight-medium">{{ model.quotation_pending }}</span></span>
                            </div>
                        </v-card-text>
                    </v-expand-transition>
                </v-card>
            </v-hover>
        </v-col>
        <v-col :class="setClass == 'col-12' ? 'pa-lg-0 pa-sm-0 pa-xs-0 mb-2 ' + setClass : 'pa-lg-0 pr-lg-2 pl-lg-2 pa-sm-0 pl-sm-0 pr-sm-2 pt-sm-4 pl-md-0 pr-md-2 pt-md-4 pa-xs-0 pl-xs-0 pr-xs-0 pt-xs-4 ' + setClass" v-if="$store.getters.checkModulePermissions('crm')">
            <v-hover v-slot:default="{ hover }">
                <v-card :elevation="hover ? 4 : 2" class="background-2 round-card">
                    <v-card-title class="pa-1 pl-0 pr-3" style="white-space: nowrap">
                        <v-subheader>Aziende</v-subheader>
                        <v-spacer></v-spacer>
                        <v-select
                            v-show="expand"                        
                            v-model="filters['company_year']"
                            :items="fieldsset.years"
                            label="Anno"
                            solo flat
                            background-color="background-2"
                            hide-details
                            style="max-width: 100px"
                            dense>
                        </v-select>
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" @click="expand = !expand" :loading="loading" icon>
                                    <v-icon>{{ expand ? 'expand_less' : 'expand_more' }}</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ expand ? 'Contrai' : 'Espandi' }}</span>
                        </v-tooltip>
                    </v-card-title>            
                    <v-expand-transition>
                        <v-card-text class="pa-0" v-show="expand">
                            <div style="display: flex; margin: auto; width: 100%; margin: auto; flex: 1 1 auto;">
                                <div class="flex-column" style="margin: auto; margin-right: 0;">
                                    <span class="display-1 margin-auto red--text text--accent3  font-weight-thin">{{ model.company_new_lead }}</span>
                                    <span class="margin-auto text-uppercase font-weight-light">Lead</span>
                                </div>
                                <div class="flex-column" style="margin: auto;">
                                    <span class="display-3 margin-auto light-green--text text--accent-4 font-weight-thin">{{ model.company_new_customer }}</span>
                                    <span class="margin-auto text-uppercase font-weight-light pb-4">Clienti</span>
                                </div>
                                <div class="flex-column" style="margin: auto; margin-left: 0;">
                                    <span class="display-1 margin-auto light-blue--text accent-3 font-weight-thin">{{ model.company_new_prospect }}</span>
                                    <span class="margin-auto text-uppercase font-weight-light">Prospect</span>
                                </div>
                            </div>
                            <v-divider></v-divider>
                            <div class="pa-4">
                                <span class="font-weight-light">Totale: <span class="font-weight-medium">{{ model.company_new }}</span></span>
                            </div>
                        </v-card-text>
                    </v-expand-transition>
                </v-card>
            </v-hover>
        </v-col>
        <v-col :class="setClass" class="pa-lg-0 pl-lg-2 pl-md-2 pr-md-2 pt-md-4 pl-sm-2 pr-sm-2 pt-sm-4 pa-xs-0 pl-xs-0 pr-xs-0 pt-xs-4" v-if="$store.getters.checkModulePermissions('opportunities')">
            <v-hover v-slot:default="{ hover }">
                <v-card :elevation="hover ? 4 : 2" class="background-2 round-card">
                    <v-card-title class="pa-1 pl-0 pr-3" style="white-space: nowrap">
                        <v-subheader>Opportunità</v-subheader>
                        <v-spacer></v-spacer>
                        <v-select
                            v-show="expand"                        
                            v-model="filters['opportunity_year']"
                            :items="fieldsset.years"
                            label="Anno"
                            solo flat
                            background-color="background-2"
                            hide-details
                            style="max-width: 100px"
                            dense>
                        </v-select>
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" @click="expand = !expand" :loading="loading" icon>
                                    <v-icon>{{ expand ? 'expand_less' : 'expand_more' }}</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ expand ? 'Contrai' : 'Espandi' }}</span>
                        </v-tooltip>
                    </v-card-title>
                    <v-expand-transition>
                        <v-card-text class="pa-0" v-show="expand">
                            <div class="flex-column">
                                <span class="display-3 margin-auto success--text font-weight-thin">{{ model.opportunity_forecast | balance }}</span>
                                <span class="margin-auto text-uppercase font-weight-light pb-4">Forecast</span>
                            </div>
                            <v-divider></v-divider>
                            <div class="pa-4">
                                <span class="font-weight-light">Totale: <span class="font-weight-medium">{{ model.opportunity_forecast_count }}</span></span>
                            </div>
                        </v-card-text>
                    </v-expand-transition>
                </v-card>
            </v-hover>
        </v-col>
    </v-row>
</template>

<script>
	export default {
        name: 'dashboard-kpi',
		data() {
            return {
                model: {},
                fieldsset: {},
                filters: {
                    'company_year': null,
                    'opportunity_year': null,
                    'pending_quotation_year': null,
                    'approved_quotation_year': null,
                },
                loading: false,
                infoLoaded: false,
                expand: JSON.parse(localStorage.getItem('dashboard_kpi'+this.$store.getters.getProfile.id)),
                kpi_count: 0,
			}
        },
        
		computed: {
            setClass() {
                this.kpi_count = 0;
                if(this.$store.getters.checkModulePermissions('opportunities')) {
                    this.kpi_count += 1
                }
                if(this.$store.getters.checkModulePermissions('crm')) {
                    this.kpi_count += 1
                }
                if(this.$store.getters.checkModulePermissions('quotations')) {
                    this.kpi_count += 2
                }
                switch(this.kpi_count) {
                    case 1:
                        return 'col-12'
                    case 2:
                        return 'col-12 col-sm-6 col-lg-6'
                    case 3:
                        return 'col-12 col-sm-4 col-lg-4'
                    case 4:
                        return 'col-12 col-sm-6 col-lg-3'
                }

            },
        },

        watch: {
            expand: {
                handler(newValue, oldValue) {
                    if(newValue == true) {
                        this.getData()
                        localStorage.setItem('dashboard_kpi'+this.$store.getters.getProfile.id, JSON.stringify(true))
                    } else {
                        localStorage.setItem('dashboard_kpi'+this.$store.getters.getProfile.id, JSON.stringify(false))
                    }
                },
                immediate: true
            },

            filters: {
                handler(newValue, oldValue) {
                    this.initialize()
                },
                deep: true,    
            },

        },        

        methods: {

            getInfo() {
                this.loading = true
                return new Promise((resolve, reject) => {
                    this.axios.get('dashboard-kpi-info').then(response => {
                        // get body data
                        this.fieldsset = response.data.info
                        this.loading = false
                        this.infoLoaded = true

                        resolve()
                    }, response => {
                        // error callback
                        this.loading = false
                        reject()
                    })
                })
            },

            getData() {
                this.getInfo().then(() => {
                    let year = _.first(this.fieldsset.years)
                    if(year) {
                        this.$set(this.filters, 'company_year', year.value)
                        this.$set(this.filters, 'opportunity_year', year.value)
                        this.$set(this.filters, 'pending_quotation_year', year.value)
                        this.$set(this.filters, 'approved_quotation_year', year.value)
                    }
                })
            },            


            initialize() {
                if(this.expand && this.infoLoaded) {
                    this.loading = true
                    this.axios.post('dashboard-kpi/', this.filters).then(response => {
                        // get body data
                        this.model = response.data.data
                        this.loading = false

                    }, response => {
                        this.loading = false
                        // error callback
                    })
                }
            },
        },

        created() {
            this.initialize()
        },

	}
</script>

<style>
    .pa-0-i {
        padding: 0px !important;
    }
</style>